import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthContext";
import LoadingScreen from "../LoadingScreen";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isInitializing } = useAuth();

  // Show loading screen while initializing
  if (isInitializing) {
    return <LoadingScreen>{null}</LoadingScreen>;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render children if authenticated
  return <>{children}</>;
};

export default ProtectedRoute;
